import React from 'react';
import { Phone } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface CallButtonProps {
  onClick: () => void;
  disabled: boolean;
  variant?: 'default' | 'neutral';
}

export const CallButton: React.FC<CallButtonProps> = ({ onClick, disabled, variant = 'default' }) => {
  const isNeutral = variant === 'neutral';
  
  return (
    <Button 
      size="icon" 
      variant="outline" 
      className={`min-w-10 min-h-10 h-10 w-10 ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${isNeutral ? 'hover:bg-muted' : 'hover:bg-green-50 hover:border-green-300'}`}
      onClick={onClick}
      disabled={disabled}
    >
      <Phone className={`h-3 w-3 ${disabled ? 'text-muted-foreground' : isNeutral ? 'text-muted-foreground' : 'text-green-600'}`} />
    </Button>
  );
};